export default function Maintenance() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#1a1a1a",
        color: "#fff",
        textAlign: "center",
        padding: 20,
      }}
    >
      <div>
        <h1>Website Under Maintenance</h1>
        <p>Please try again later.</p>
      </div>
    </div>
  );
}
